import axios from "axios";

export default function FulfillmentItemFormService(formData, fullfillmentId, itemId, method) {
  let id
  let url
  if(formData && formData.id) {
    id = formData.id
    url = process.env.REACT_APP_API_HOST + "/fulfillment/" + fullfillmentId + "/item/" + itemId
  }
  else {
    url = process.env.REACT_APP_API_HOST + "/fulfillment/" + fullfillmentId + "/items"
  }
  return axios({
    method: method,
    url: url,
    data: formData,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
